import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { AnabizPaymentInputApproverListComponent } from './anabiz-payment-input-approver-list.component';

export interface AnabizPaymentInputApproverListPayload {}

export function defaultApproverListModalParts(): ModalBlockParts {
  return {
    id: 'paymentDetailsModalParts',
    block: AnabizPaymentInputApproverListComponent,
    closeBackEnable: true,
    type: ModalType.TYPE1,
    modalWidth: LModalContentsWidthType.MODAL_PC_W600,
  };
}
